import localStorage from './angular-local-storage';

var isDefined = angular.isDefined,
  isUndefined = angular.isUndefined,
  isNumber = angular.isNumber,
  isObject = angular.isObject,
  isArray = angular.isArray,
  extend = angular.extend,
  toJson = angular.toJson;


// Test if string is only contains numbers
// e.g '1' => true, "'1'" => true
function isStringNumber(num) {
  return /^-?\d+\.?\d*$/.test(num.replace(/["']/g, ''));
}

export default angular.module("temporaryStorage", [localStorage.name])
.service("temporaryStorageService", ["localStorageService", "$parse", function(localStorageService, $parse){
	var storage = angular.copy(localStorageService);
	var expirationMinutes = 60;
	var getIgnoreExpiration = function(key) {
		var tempVal = localStorageService.get(key);
		if(!tempVal || !tempVal.expirationDate) return null;
		return tempVal;
	};
	var get = function(key) {
		var tempVal = getIgnoreExpiration(key);
		if(!tempVal) return null;
		if(new Date() > new Date(tempVal.expirationDate)) {
			localStorageService.remove(key);
			return null;
		}
		return tempVal.value;
	};
	var set = function(key, value) {
		var now = new Date();		
		return localStorageService.set(key, 
			{
				value: value, 
				expirationDate: new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() + expirationMinutes)
			});
	};
	var bind = function(scope, key, def, lsKey) {
		// básicamente una copia de la función original pero con validación de "expiración" custom
		lsKey = lsKey || key;
		var value = getIgnoreExpiration(lsKey);
		if(value) value = value.value;

		if (value === null && isDefined(def)) {
			value = def;
		} else if (isObject(value) && isObject(def)) {
			value = angular.extend(def, value);
		}

		$parse(key).assign(scope, value);

		return scope.$watch(key, function(newVal) {
			set(lsKey, newVal);
		}, isObject(scope[key]));
	};

	return angular.extend(storage, 
		{
			set: set,
			get: get,
			bind: bind
		});
}]);
